import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { styled } from '@mui/system';
import { useState } from 'react';

import styles from '../../styles/Episodes.module.scss';

const dropdownMenuProps = {
  boxShadow: '2px 2px 8px rgba(0, 0, 0, 0.12)',
  borderRadius: '0px 0px 16px 16px',
};

export const SelectField = styled((props) => (
  <Select
    {...props}
    sx={{ marginRight: '40px', width: props.width ? props.width : '240px' }}
    MenuProps={{
      PaperProps: {
        sx: dropdownMenuProps,
      },
    }}
  />
))((props) => ({
  '& .MuiSelect-select:focus': {
    borderRadius: '32px !important',
  },
  '& .MuiOutlinedInput-input': {
    border: '1px solid #1d76bb',
    borderRadius: '32px',
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 400,
    fontSize: '16px',
    paddingLeft: '24px',
    paddingRight: '38px',
    color: props?.custVariant === 'dark' ? '#1D76BB' : '#1D76BB',
    backgroundColor: props?.custVariant ? '#e9eef5' : '',
    '&:active': {
      backgroundColor: props?.custVariant ? '#1D76BB' : '',
      color: props?.custVariant === 'dark' ? '#e9eef5' : '#1D76BB',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  svg: {
    top: '50%',
    transform: 'translateY(-50%)',
    right: '16px',
  },

  ' & .MuiList-root .MuiMenu-list': {
    color: '#1D76BB',
    borderRadius: '0px 0px 16px 16px',
  },
  '.select': {
    backgroundColor: 'black',
  },
}));

export const SelectMenuItem = styled((props) => <MenuItem {...props} />)(
  () => ({
    '&': {
      color: '#1D76BB',
      fontSize: '16px',
      lineHeight: '24px',
      padding: '16px',
      margin: '0',
      overflow: 'visible',
      minWidth: '228px',
      ':hover': {
        backgroundColor: '#e9eef5',
      },
    },
    '&.Mui-selected ': {
      backgroundColor: '#E9EEF5',
    },
  })
);

export const MobileSort = ({ children, theme = 'blue', button = true }) => {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(false);
  };

  return (
    <div className={styles.mobileSortContainer}>
      <img
        src={theme === 'blue' ? '/blueSort.svg' : '/sort.svg'}
        onClick={() => setClicked(true)}
      />
      {clicked && (
        <div className={styles.clickedWrapper}>
          <div className={styles.clickedContainer}>
            <p>
              Sortowanie
              <img
                src='/close.svg'
                alt='Close button'
                onClick={() => setClicked(false)}
              />
            </p>
            {children}
            {button && <button onClick={handleClick}>Sortuj</button>}
          </div>
        </div>
      )}
    </div>
  );
};

export const MobileSelect = ({ click = () => {}, options, defaultHeader }) => {
  const [showWrapper, setShowWrapper] = useState(false);
  const [activeHeader, setActiveHeader] = useState(defaultHeader);

  const handleSortWrapper = () => {
    setShowWrapper(!showWrapper);
  };

  const handleClick = (e, option) => {
    setActiveHeader(option.name);
    handleSortWrapper();
    click && click(e.target.getAttribute('value'));
  };

  return (
    <>
      <div
        className={
          showWrapper
            ? `${styles.select} ${styles.activeSelect}`
            : styles.select
        }
        value={'date'}
        onClick={handleSortWrapper}
      >
        <p>{activeHeader}</p>
      </div>
      {showWrapper && (
        <div className={styles.optionsWrapper}>
          {options.map((option, id) => (
            <p
              key={option + id}
              value={option.value}
              onClick={(e) => handleClick(e, option)}
              className={styles.option}
            >
              {option.name}
            </p>
          ))}
        </div>
      )}
    </>
  );
};
